
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class B2CStatewiseGstReportSummaryGrid extends Serenity.EntityGrid<B2CStatewiseGstReportSummaryRow, any> {
        protected getColumnsKey() { return B2CStatewiseGstReportSummaryColumns.columnsKey; }
        protected getDialogType() { return B2CStatewiseGstReportSummaryDialog; }
        protected getIdProperty() { return B2CStatewiseGstReportSummaryRow.idProperty; }
        protected getInsertPermission() { return B2CStatewiseGstReportSummaryRow.insertPermission; }
        protected getLocalTextPrefix() { return B2CStatewiseGstReportSummaryRow.localTextPrefix; }
        protected getService() { return B2CStatewiseGstReportSummaryService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}